import { React, Link } from 'react';


const getText = () => {
    return {


        "ERROR_WHILE_CONNECTING_TO_SERVER": () => {
            return "Network error";
        },

        "CONFIRM_DELETE_MODAL_TITLE": () => {
            return `Delete confirm`;
        },

        "CONFIRM_DELETE_MODAL_BODY": (params) => {
            const { item } = params;
            const _name = Array.isArray(item) ? `${item.length} elements` : item.item.Name
            return `Are you sure that you want to delete ${_name}?`;

        },

        "CLOSE": () => {
            return `Close`;
        },

        "DELETE": () => {
            return `Delete`;

        },
        "DELETE_LONG_MESSAGE": () => {
            return `Yes, delete it!`
        },
        "CLOSE_LONG_MESSAGE": () => {
            return `No, cancel it!`
        },
        "FILE_NOT_FOUND": () => {
            return `File not found`
        },
        "ERROR": () => {
            return `Error`
        },
        "YES": () => {
            return `Yes`
        },
        "NO": () => {
            return `No`
        }
    }



}

export { getText };